import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';

import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';

import { BidNotificationInfo, BmDataAccessFacade } from '@nexweb/shared/data-access/bm';

import { RequestExtensionOfActivationPeriod } from '../../../models';
import { RequestExtensionOfActivationPeriodService } from '../../../services';
import { ExtTsoResponseFormComponent } from './ext-tso-response-form.component';

@Component({
  selector: 'nexweb-ext-tso-response',
  templateUrl: './ext-tso-response.component.html',

  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ExtTsoResponseFormComponent, AsyncPipe],
})
export class ExtTsoResponseComponent implements OnInit {
  @Input() bidId: number;

  public response$: Observable<RequestExtensionOfActivationPeriod.ExtensionResponse>;
  public labels: RequestExtensionOfActivationPeriod.ExtensionResponseLabels;
  public dateTimeFormat: string;
  public accepted: boolean;
  public confirmedFullDispatchTime: Date;
  public rejectReason: string;
  public concurrencyStamp: string;
  public isFormValid = true;

  private requestExtensionActivationPeriodService = inject(RequestExtensionOfActivationPeriodService);
  private bmFacade = inject(BmDataAccessFacade);

  ngOnInit(): void {
    this.labels = this.requestExtensionActivationPeriodService.getTsoResponseLabels();
    this.dateTimeFormat = this.requestExtensionActivationPeriodService.getDateTimeFormat();

    this.initialiseData();
  }

  public formValuesChanged(event): void {
    if (event.confirmedFullDispatchTime) {
      this.confirmedFullDispatchTime = event.confirmedFullDispatchTime.value;
    }

    if (event.activationRequestAccepted instanceof Object) {
      this.accepted = event.activationRequestAccepted.value;
    } else {
      this.accepted = event.activationRequestAccepted;
    }

    if (event.reasonForDeclining) {
      this.rejectReason = event.reasonForDeclining;
    }

    if (event.concurrencyStamp) {
      this.concurrencyStamp = event.concurrencyStamp;
    }
  }

  public formValidationChanged(event): void {
    this.isFormValid = event;
  }

  private initialiseData(): void {
    this.response$ = this.bmFacade.getBidNotificationInfo(this.bidId).pipe(
      map(
        (bidNotificationInfo: BidNotificationInfo) =>
          ({
            concurrencyStamp: bidNotificationInfo.concurrencyStamp,
            instrument: bidNotificationInfo.instrument,
            requestingTsoPortfolio: bidNotificationInfo.requestingTsoPortfolioName,
            supplyingBspPortfolio: bidNotificationInfo.supplyingBspPortfolioName,
            requestedQuantity: bidNotificationInfo.requestedQuantity
              ? bidNotificationInfo.requestedQuantity.toString()
              : ' ',
            defaultFullDispatchTime: bidNotificationInfo.defaultFullDispatchTime,
            confirmedFullDispatchTime: bidNotificationInfo.requestFullDispatchTime,
            activationRequestAccepted: true,
            reasonForDeclining: bidNotificationInfo.rejectReason,
          }) as RequestExtensionOfActivationPeriod.ExtensionResponse,
      ),
    );
  }
}
